import '../assets/NcCheckboxRadioSwitch-BkBep4wT.css';
import { r as register } from "./_l10n-DDx8P-X1.mjs";
register();
